import "./Footer.css";
const Footer = () => {
  return (
    <div className="footer-container">
      <p>
        Made by <span>Emmanuelle Baron - 2021</span>
      </p>
    </div>
  );
};

export default Footer;
